module.exports = __webpack_public_path__ + "img/logo.91831826.svg";